var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 23"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 0H3a3 3 0 00-3 3v12a3 3 0 003 3h4.898L12 22.922 16.102 18H21a3 3 0 003-3V3a3 3 0 00-3-3zm-7.5 12H5.25v-1.5h8.25V12zm5.25-4.5H5.25V6h13.5v1.5z",
    fill: "#D3D2CE"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyMyI+PHBhdGggZD0iTTIxIDBIM2EzIDMgMCAwMC0zIDN2MTJhMyAzIDAgMDAzIDNoNC44OThMMTIgMjIuOTIyIDE2LjEwMiAxOEgyMWEzIDMgMCAwMDMtM1YzYTMgMyAwIDAwLTMtM3ptLTcuNSAxMkg1LjI1di0xLjVoOC4yNVYxMnptNS4yNS00LjVINS4yNVY2aDEzLjV2MS41eiIgZmlsbD0iI0QzRDJDRSIgZmlsbC1ydWxlPSJub256ZXJvIi8+PC9zdmc+";
export { SvgMessage as ReactComponent };